import React from "react";
import SimpleButton from "./SimpleButton";

const NextButton = ({IsonRecorder, ...props}) => (
  <SimpleButton
    outline
    type="button"
    className={
      IsonRecorder
        ? "btn px-3 disabled"
        : "btn px-3"
      }
    style={{ backgroundColor: "rgb(255, 182, 29)", borderColor: "rgb(255, 182, 29)", color: "black" }}
    label="Next"
    {...props}
  />
);

export default NextButton;
